<template>
  <b-modal
    id="add_payment_gateway_modal"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    :title="modalTitle"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="addPaymentGatewayForm"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <b-row>
            <b-col md="6">
              <b-form-group
                class="required gateway-label"
                label="Name"
                label-for="h-name"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  placeholder="Enter name"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                class="required gateway-label"
                label="Merchant ID"
                label-for="h-merchantId"
              >
                <b-form-input
                  id="merchantId"
                  v-model="form.merchant_id"
                  placeholder="Enter merchant Id"
                  type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                class="required gateway-label"
                label="Merchant Secret"
                label-for="h-merchantSecret"
              >
                <b-form-input
                  id="merchantSecret"
                  v-model="form.merchant_secret"
                  placeholder="Enter merchant secret"
                  type="text"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                class="required gateway-label"
                label="Environment"
                label-for="h-environment"
              >
                <v-select
                  v-model="form.environment"
                  :options="environmentOptions"
                  :reduce="option => option.value"
                  label="name"
                  autocomplete="nope"
                  placeholder="Select environment"
                  :clearable="false"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- submit and reset -->
          <b-row>
            <b-col cols="12 mb-1">
              <div class="d-flex justify-content-end">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Submit
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                >
                  Clear
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BFormGroup,
  BForm,
  BFormInput,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const PaymentRepository = RepositoryFactory.get('payment')

function initialState() {
  return {
    open: false,
    modalLoading: false,
    loading: false,
    environmentOptions: [
      { name: 'Sandbox', value: 'sandbox' },
      { name: 'Live', value: 'live' },
    ],
    form: {},
    modalType: '',
    id: null,
    // environment: '',
    // gatewayName: '',
    // merchantId: '',
    // merchantSecret: '',
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BFormInput,
    BRow,
    BOverlay,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    modalTitle() {
      // eslint-disable-next-line no-nested-ternary
      return this.modalType === 'add' ? 'ADD NEW PAYMENT GATEWAY' : 'UPDATE PAYMENT GATEWAY'
    },
  },
  methods: {
    async openModal(id, type) {
      await Object.assign(this.$data, initialState())
      this.open = true
      this.id = id
      this.modalType = type
      if (this.modalType === 'edit') {
        await this.fetchPaymentGatewayDetails(this.id)
      }
    },
    async onSubmit() {
      this.modalLoading = true
      try {
        const payload = {
          name: this.form.name,
          merchant_id: this.form.merchant_id,
          merchant_secret: this.form.merchant_secret,
          environment: this.form.environment,
        }
        if (this.modalType === 'add') {
          await PaymentRepository.addPaymentGateway(payload)
        } else {
          await PaymentRepository.updatePaymentGateway(this.id, payload)
        }
        this.showSuccessMessage(`Payment Gateway ${this.modalType === 'add' ? 'Added' : 'Updated'} Successfully`)
        this.open = false
        this.$parent.getPaymentGatewayList()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
    async fetchPaymentGatewayDetails(id) {
      this.modalLoading = true
      try {
        const { data } = await PaymentRepository.getPaymentGatewayByID(id)
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.modalLoading = false
    },
  },
}
</script>
<style scoped>
@import "../../../node_modules/@syncfusion/ej2-base/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-inputs/styles/fabric.css";
@import "../../../node_modules/@syncfusion/ej2-buttons/styles/fabric.css";
</style>
<style lang="scss">
@import '@core/scss/vue/required.scss';

.gateway-label label {
  font-size: 1rem !important; /* This will apply to all labels, adjust if needed */
}

.waybill-content {
  .required::after {
  content: "*";
  color: #ea5455;
}
}

@media screen and (max-width: 767px) {
    /* Add the following styles for mobile view */
    .mobile-stack {
      flex-direction: column !important;
    }
    .mobile-full-width {
      width: 100% !important;
    }
  }
</style>
